// extracted by mini-css-extract-plugin
module.exports = {"container":"favs_container__1T6OY"};